import { TimestampedMeasure } from '@tableau/metrics-shared-widgets-dom/lib/src/models';
import { Action } from 'redux';

import { IMetricWithParsedData } from '../../../metrics/models';
import { IMetricInfo } from '../../../ts/models/IMetricInfo';
import { IMetricWithSummaryData } from '../../../ts/ServerApi/types/IMetricWithSummaryData';
import { UpdateMetricsValues, UpdateMetricsValuesSucceeded } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface UpdateMetricsActions extends Action {
  metrics: IMetricInfo[];
}

export function updateMetricsValues(metrics: IMetricInfo[]): UpdateMetricsActions {
  return {
    type: UpdateMetricsValues,
    metrics
  };
}

export interface UpdateMetricsValuesSucceededAction extends Action {
  readonly metrics: ReadonlyArray<IMetricWithParsedData>;
}

export function updateMetricsValueRequestSucceeded(metrics: ReadonlyArray<IMetricWithParsedData>): UpdateMetricsValuesSucceededAction {
    return {
      type: UpdateMetricsValuesSucceeded,
      metrics
    };
  }

export const isMetricsValueRequestSucceededAction = isActionFactory<UpdateMetricsValuesSucceededAction>(UpdateMetricsValuesSucceeded);
export const isUpdateMetricsActions = isActionFactory<UpdateMetricsActions>(UpdateMetricsValues);
